import { createSelector } from 'reselect'

const getOnboardingData = state => state.onboarding
const getAccountData = state => state.myAccount
const getLessons = state => state.lessons
const getUser = state => state.user
const getStep = (state, props) => props && props.match ? props.match.params.step : 0

const defaultGrades = [], defaultSubjects = [], defaultPreview = {name: '', description: '', previewID: '', author_name: '', author_thumb: ''}
const NUMBER_OF_SELECTABLE_LESSONS = 3

const onboardingViewSelector = createSelector(
	[getOnboardingData, getAccountData, getLessons, getUser, getStep],
	(onboarding, account, lessons, user) => {

		const suggested = onboarding.suggested.map(function(id) {
			return lessons[id]
		})

		const fromStore = onboarding.fromStore
		const firstStep = fromStore ? 1 : 0

		let previewData
		if (onboarding.previewID) {
			const lesson = lessons[onboarding.previewID]
			previewData = {
				name: lesson.data.name,
				description: lesson.data.description,
				previewID: onboarding.previewID,
				author_name: lesson.data.author.data.name,
				author_thumb: lesson.data.author.data.thumb,
			}
		} else {
			previewData = defaultPreview
		}

		const gradeData = {
			value: onboarding.grades.length ? onboarding.grades : '',
			initialValue: '',
		}
		if (!onboarding.grades_updated && account.data.gradeIds && account.data.gradeIds.length) {
			gradeData.initialValue = account.data.gradeIds
		}

		const subjectData = {
			value: onboarding.subjects.length ? onboarding.subjects : '',
			initialValue: '',
		}
		if (!onboarding.subjects_updated && account.data.subjectIds && account.data.subjectIds.length) {
			subjectData.initialValue = account.data.subjectIds
		}

		return {
			firstStep,
			fromStore,
			onboarding,
			loopComplete: onboarding.loopComplete > 1,
			grades: account.data.grades || defaultGrades,
			grade: gradeData,
			subjects: account.data.subjects || defaultSubjects,
			interests: onboarding.interests,
			technology: onboarding.technology,
			subject: subjectData,
			remainingLessons: NUMBER_OF_SELECTABLE_LESSONS - onboarding.selected.length,
			canAddLessons: onboarding.selected.length < NUMBER_OF_SELECTABLE_LESSONS,
			suggested,
			firstName: user.data.firstName || '',
			userDataLoaded: !!user.fullDataLoaded,
			preview: previewData,
			exitComplete: onboarding.loopComplete > 1 && onboarding.loadedAssets === 8 && onboarding.loadingComplete,
		}
	}
)

export default onboardingViewSelector
